export const hoursToMinutes = (hours: number): number => hours * 60;

export const minutesToMs = (minutes: number): number => minutes * 60000;
